import {
  subscribeToFrames,
  subscribeToReconnect,
} from "@notifications/notificationFrames";
import { type QueryKey, useQueryClient } from "@tanstack/react-query";
import { useEffect, useEffectEvent } from "react";

/**
 * Invalidates `queryKey` when a frame of one of `types` names `uuid`, and on
 * every socket reconnect (missed frames are never replayed). `uuid: null`
 * subscribes to nothing.
 */
export const useFrameRefresh = (
  types: readonly string[],
  uuid: string | null,
  queryKey: QueryKey,
) => {
  const queryClient = useQueryClient();
  const refresh = useEffectEvent(() => {
    void queryClient.invalidateQueries({ queryKey });
  });
  const watched = useEffectEvent((type: string) => types.includes(type));
  useEffect(() => {
    if (uuid === null) return;
    const frames = subscribeToFrames((events) => {
      if (events.some((event) => event.uuid === uuid && watched(event.type)))
        refresh();
    });
    const reconnect = subscribeToReconnect(() => refresh());
    return () => {
      frames();
      reconnect();
    };
  }, [uuid]);
};
